// WeChat desktop also has MicroMessenger; only mobile WeChat uses long-press.
export function wechatLongPressLogin(agent = '', touchPoints = 0) {
  const mobile = /Android|iPhone|iPad|iPod|Mobile/i.test(agent) || /Macintosh/i.test(agent) && touchPoints > 1
  return mobile && /MicroMessenger/i.test(agent)
}


// Only WeChat's official authorization endpoint may receive a login navigation.
export function validateWechatMobileUrl(value, origin) {
  let url
  try { url = new URL(value) } catch (_) { throw new Error('INVALID_RESPONSE') }
  if (url.origin !== 'https://open.weixin.qq.com' || url.pathname !== '/connect/oauth2/authorize'
      || url.username || url.password || url.searchParams.get('scope') !== 'snsapi_userinfo'
      || url.searchParams.get('response_type') !== 'code'
      || !/^wx[0-9a-zA-Z]{16}$/.test(url.searchParams.get('appid') || '')
      || !/^[A-Za-z0-9_-]{43}$/.test(url.searchParams.get('state') || '')
      || url.searchParams.get('redirect_uri') !== origin + '/api/wx/mobile/callback') throw new Error('INVALID_RESPONSE')
  return url.href
}

// Capture the successful OAuth return before the router normalizes the hash.
export function takeMobileLoginReturn(location, history) {
  const url = new URL(location.href)
  const separator = url.hash.indexOf('?')
  if (separator < 0) return null
  const query = new URLSearchParams(url.hash.slice(separator + 1))
  if (!query.has('wxLoginState')) return null
  const state = query.get('wxLoginState')
  query.delete('wxLoginState')
  url.hash = url.hash.slice(0, separator) + (query.toString() ? '?' + query.toString() : '')
  history.replaceState(history.state, '', url.pathname + url.search + url.hash)
  return state
}
